import { IInsuranceCoverage } from "./types";
import { insuranceCoverageService } from "./service";

export const getInsuranceCoverage = async (
  insuranceCoverageId: string
): Promise<IInsuranceCoverage> => {
  const { data } = await insuranceCoverageService.get<IInsuranceCoverage>(
    `/${insuranceCoverageId}`
  );
  return data;
};
